import * as amplitude from '@amplitude/analytics-browser';
import { CookieService } from '../services/cookie.service';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { Utils } from './utils';

// Add engagement plugin to amplitude
amplitude.add(engagementPlugin());

// Environment-specific Amplitude API keys
const amplitudeKeyForEnv = {
  prod: '37b2d2468c9ecf98ae4952e03b6dda94',
  dev: 'd8851c6165d1d96631ac05e808ef4a45',
  qa: 'd8851c6165d1d96631ac05e808ef4a45',
  stg: 'd8851c6165d1d96631ac05e808ef4a45',
  local: '',
};

// Detect current environment based on hostname
export const getEnvironment = () => {
  const host = window.location.hostname;

  if (host.includes('localhost')) return 'local';
  if (host.includes('qa')) return 'qa';
  if (host.includes('staging') || host.includes('stg')) return 'stg';
  if (host.includes('dev')) return 'dev';
  return 'prod';
};

// Initialize Amplitude with environment key and user ID
export const initAmplitude = (userId) => {
  if (getEnvironment() !== 'local') {
    const env = getEnvironment();
    const apiKey = amplitudeKeyForEnv[env];
    amplitude.init(apiKey, userId, { autocapture: false });
  }
};

// Track an event
export const trackEvent = (eventName, eventProps = {}) => {
  if (getEnvironment() !== 'local') {
    const omniProfile = JSON.parse(CookieService.getCookie('omniProfile'));
    eventProps['env'] = getEnvironment();
    eventProps['app_source'] = 'MediaOps';
    eventProps['guid_client'] = Utils.getRouteParam("clientid");
    eventProps['guid_person'] = omniProfile?.personId;
    eventProps['email'] = omniProfile?.email;
    amplitude.track(eventName, eventProps);
  }
};

// Set user properties
// export const setUserProperties = (props) => {
//   if (getEnvironment() !== 'local') {
//     amplitude.setUserProperties(props);
//   }
// };

// Identify user (this automatically works with Guides & Surveys)
export const identifyUser = (userId, userTraits = {}) => {
  if (getEnvironment() !== 'local') {
    try {
      const omniProfile = JSON.parse(CookieService.getCookie('omniProfile') || '{}');
      const identifyProps = {
        ...userTraits,
        email: omniProfile?.email,
        personId: omniProfile?.personId,
        clientId: Utils.getRouteParam("clientid"),
        environment: getEnvironment(),
      };
      
      // Create identify instance and set properties
      const identifyEvent = new amplitude.Identify()
        .setOnce('first_used', new Date())
        .set(identifyProps);
      
      amplitude.identify(identifyEvent);
    } catch (error) {
      console.error('Error identifying user with Amplitude:', error);
    }
  }
};

// Export amplitude instance for direct access to guides/surveys
export { amplitude };
